<header class="app-header">
  <!-- Hamburger area (within sidenav width) -->
  <div class="app-header__left">
    @if (showHamburger()) {
      <button
        type="button"
        mat-icon-button
        class="app-header__hamburger"
        (click)="hamburgerClick.emit()"
        aria-label="Toggle navigation">
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>

  <!-- Logo aligned with main body left edge -->
  @if (displayLogoUrl()) {
    <div
      class="app-header__logo"
      [style.background-image]="'url(' + displayLogoUrl() + ')'">
    </div>
  }

  <div class="app-header__spacer"></div>

  <div class="app-header__right">
    <!-- Workspace selector - before help button (wrapped for responsive positioning) -->
    <div class="section-select-anchor">
      <ng-content select="[workspaceSelector]"></ng-content>
    </div>

    @if (showHelp()) {
      <button
        mat-icon-button
        class="app-header__help-btn"
        (click)="helpClick.emit()"
        aria-label="Help">
        <mat-icon>help_outline</mat-icon>
      </button>
    }

    <button
      mat-icon-button
      class="app-header__theme-btn"
      (click)="themeToggle.emit()"
      [attr.aria-label]="themeLabel()"
      [attr.aria-pressed]="isDarkMode()">
      <mat-icon>{{ themeIcon() }}</mat-icon>
    </button>

    <!-- Language switcher flag button -->
    <button
      mat-icon-button
      class="app-header__lang-btn"
      [matMenuTriggerFor]="langMenu"
      [attr.aria-label]="'Language: ' + currentLangLabel()">
      <img
        class="app-header__flag-img"
        [src]="currentFlag()"
        [alt]="currentLangLabel()">
    </button>

    <mat-menu #langMenu="matMenu" xPosition="before">
      <div class="lang-switcher-marker" style="display:none"></div>
      @for (lang of languages; track lang.code) {
        <button
          mat-menu-item
          class="lang-item-list"
          (click)="switchLanguage(lang.code)"
          [class.active]="currentLang() === lang.code">
          <img
            class="lang-flag-img"
            [src]="lang.flag"
            [alt]="lang.label">
          <span>{{ lang.label }}</span>
        </button>
      }
    </mat-menu>

    <button mat-button class="app-header__profile" [matMenuTriggerFor]="profileMenu">
      <span class="profile-avatar">{{ userName() | slice:0:1 }}</span>
      <span class="profile-role">{{ userRole() }}</span>
    </button>

    <mat-menu #profileMenu="matMenu" panelClass="profile-menu" xPosition="before">
      <!-- Account info header -->
      <div class="profile-menu__account">
        <span class="profile-menu__account-label" i18n="@@shared.appHeader.label.accountName">アカウント名</span>
        <span class="profile-menu__account-id">{{ userName() || '(未取得)' }}</span>
      </div>
      <mat-divider></mat-divider>

      <!-- Menu items from parent (admin menus) -->
      <ng-content select="[profileMenuItems]"></ng-content>

      <!-- Details submenu -->
      <button mat-menu-item [matMenuTriggerFor]="detailsMenu">
        <mat-icon>info_outline</mat-icon>
        <span i18n="@@shared.appHeader.button.viewDetails">詳細を見る</span>
      </button>

      @if (showFaq()) {
        <mat-divider></mat-divider>
        <button mat-menu-item class="external-link" (click)="openFaq()">
          <span i18n="@@shared.appHeader.menu.faq">？ よくある質問</span>
          <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
        </button>
      }

      <!-- Logout -->
      <button mat-menu-item (click)="logoutClick.emit()">
        <mat-icon>logout</mat-icon>
        <span i18n="@@shared.appHeader.button.logout">ログアウト</span>
      </button>
    </mat-menu>

    <!-- Details submenu -->
    <mat-menu #detailsMenu="matMenu" class="details-menu">
      <div class="details-menu-marker" style="display:none"></div>
      <button mat-menu-item class="external-link" (click)="navigateToPage('tou')">
        <span i18n="@@shared.appHeader.menu.termsOfUse">利用規約</span>
        <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
      </button>
      <button mat-menu-item class="external-link" (click)="navigateToPage('privacy')">
        <span i18n="@@shared.appHeader.menu.privacyPolicy">プライバシーポリシー</span>
        <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
      </button>
      @if (isDebug) {
        <button mat-menu-item class="external-link" (click)="navigateToPage('license')">
          <span i18n="@@shared.appHeader.menu.license">ライセンス</span>
          <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
        </button>
      }
      @if (common.doesSystemAdminKeyExist()) {
        <button mat-menu-item class="external-link" (click)="navigateToPage('build-info')">
          <span i18n="@@shared.appHeader.menu.buildInfo">ビルド情報</span>
          <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
        </button>
      }
    </mat-menu>

  </div>
</header>
